// eslint-disable-next-line no-unused-vars
import React, {useEffect, useState} from 'react';
import {GoogleLogin} from '@react-oauth/google';
import {Dialog, Modal, Text} from 'react-aria-components';
import {Link, Navigate, useSearchParams} from "react-router-dom";
import {toast} from "react-toastify";

import Header from "../../components/Header/Header";
import "./Login.css";
import apiClient from "../../utils/api";
import Logo from "../../components/Logo/Logo";

function Login() {
    const [redirectTo, setRedirectTo] = useState(null)
    const [error, setError] = useState(null)
    const [googleToken, setGoogleToken] = useState(null)
    const [searchParams] = useSearchParams();

        useEffect(() => {
            const message = searchParams.get("toastMessage");
            if (message) {
                toast.warn(decodeURIComponent(message));
            }
        }, []);

    async function onLoginSuccess(tokenResponse) {
        setGoogleToken(tokenResponse)
    }

    function onLoginError() {
        console.log("error!")
    }

    useEffect(() => {
        apiClient.getLogin(googleToken).then((data) => {
            if (data === undefined) {
                return
            }
            setRedirectTo("/")
            localStorage.setItem("profile", JSON.stringify(data))
        })
    }, [googleToken]);

    if (redirectTo) {
        return <Navigate to={redirectTo} />
    }

    return (
        <>
            <Header />
            <Modal isOpen={true} isDismissable={false}>
                <Dialog id="login-dialog" aria-label="Veil Stream" className={error ? "error" : ""}>
                    <div className="row">
                        <Logo />
                    </div>
                    <div className="row">
                        <Text>
                            Sign in to VeilStream to manage data access.
                        </Text>
                    </div>
                    <div className="row google-login-button">
                        <GoogleLogin
                            onSuccess={onLoginSuccess}
                            onError={onLoginError}
                        />
                    </div>
                    <div className="row">
                        <Text>
                            Don't have a Google account?
                            Click <Link to="https://www.veilstream.com/authorization-request">here</Link>.
                        </Text>
                    </div>
                    <div className="row">
                        <Text className="error-message">
                            {error}
                        </Text>
                    </div>
                </Dialog>
            </Modal>
        </>
)
}

export default Login
